// Modules
import { useEffect, useState } from 'react'
import axios from 'axios'

// Helpers
import { checkIfTokenIsValid, getRemainingTokenTime, getToken, logout, storeToken } from 'helpers/authentication'

// Constants
import { REFRESH_URL } from 'constants/environment'
import { TOKEN_EXPIRATION_IN_MINUTES } from 'constants/settings'

// Data (Local)
const tokenExpirationTimeLimit = TOKEN_EXPIRATION_IN_MINUTES * 60 * 1000

// Hook: Authentication > Token
// WARNING: Do not call this hook in more than one place in the application
function useToken () {
	// State
	const [token, setToken] = useState(null)

	// Effects
	useEffect(() => {
		async function handleToken () {
			try {
				const refreshToken = getToken()?.refreshToken
				const { data } = await axios({ data: { refreshToken }, method: 'POST', url: REFRESH_URL })
				if (!!data) {
					setToken(data)
					storeToken(data)
				}
			} catch (error) {
				console.error('AIX | Token refresh error:', error.message)
				logout()
			}
		}
		// Initial token
		if (checkIfTokenIsValid()) {
			const storedToken = getToken()
			if (getRemainingTokenTime(storedToken) < tokenExpirationTimeLimit / 2) handleToken()
			else setToken(storedToken)
		} else logout()
	}, [])

	// Response
	return token
}

// Export
export default useToken
